import { useCallback, useState } from "react";
import AvatarLightbox from "@/components/AvatarLightbox";

/**
 * useAvatarPeek — tiny controller for the AvatarLightbox.
 *
 * Usage:
 *   const peek = useAvatarPeek();
 *   <div onClick={() => peek.open(user)}>…</div>
 *   {peek.node}
 *
 * Keeps every surface (PostCard author row, LiveRoom host chip, Admin user
 * row, DM thread header) consistent — one lightbox instance per component,
 * no prop-drilling.
 */
export default function useAvatarPeek() {
  const [state, setState] = useState({ open: false, src: null, handle: null });

  const open = useCallback((userLike) => {
    if (!userLike) return;
    setState({
      open: true,
      src: userLike.avatar_url || null,
      handle: userLike.handle || null,
      handleHidden: !!userLike.handle_hidden,
    });
  }, []);

  const close = useCallback(() => {
    setState((s) => ({ ...s, open: false }));
  }, []);

  const node = (
    <AvatarLightbox
      open={state.open}
      onClose={close}
      src={state.src}
      handle={state.handle}
      handleHidden={state.handleHidden}
    />
  );

  return { open, close, node };
}
